<div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="general" role="tabpanel" aria-labelledby="general-tab">
        <div class="itinerary-tab-header">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" @click="redirectToGeneral">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#day1"
                        role="tab" aria-controls="home" aria-selected="true">
                        <i class="fas fa-align-justify"></i> General
                    </a>
                </li>
                <li class="nav-item" @click="redirectToPriceDuration">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#day2" role="tab"
                            aria-controls="profile" aria-selected="false">
                            <i class="fas fa-dollar-sign"></i> Price and Duration
                        </a>
                    </li>
                <li class="nav-item" @click="redirectToPricingRule" v-if="permission.trekPricing_list">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#day2" role="tab"
                        aria-controls="profile" aria-selected="false">
                        <i class="fas fa-dollar-sign" ></i> Pricing Rule
                        
                    </a>
                </li>
                <li class="nav-item" @click="redirectToDestinations">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day5" role="tab"
                        aria-controls="contact" aria-selected="false">
                        <i class="fas fa-map-marker-alt"></i> Destinations Covered
                    </a>
                </li>
                <li class="nav-item" @click="redirectToHighlights" v-if="permission.trekHighlight_list">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day4" role="tab"
                        aria-controls="contact" aria-selected="false">
                        <i class="fas fa-magic"></i> Highlights
                    </a>
                </li>
                <li class="nav-item" @click="redirectToImportantNotes">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day3" role="tab"
                        aria-controls="contact" aria-selected="false">
                        <i class="fas fa-exclamation-circle"></i> Important Notes
                    </a>
                </li>
                
            </ul>
            <div class="tab-content" id="">
                    <router-view></router-view>
            </div>
        </div>
    </div>
</div>

